module.exports = __webpack_public_path__ + "img/sec4_3.45a684a4.png";